import postRequest from '../../../postRequest';

/**
 * Update user into PRISM db.
 *
 * @param {string} groupName - jdITGroup
 * @param {Array[number]} siteIds - [0, 1]
 * @param {string} id - 3fa85f64-5717-4562-b3fc-2c963f66afa6com
 * @returns {object} { Success: true, Error: null }
 */
function postUpdateGroup(
  id,
  groupName,
  sites,
) {
  const endpoint = '/users-management/update-user-group';

  const body = {
    id,
    groupName,
    sites,
  };
  return new Promise((resolve, reject) => {
    postRequest(endpoint, body, 'Update Group')
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  });
}

export default postUpdateGroup;
